<template>
    <sub-page :fullPage="true">
        <section class="survey-title">
            <h1 class="title">{{surveyData.name}}</h1>
            <p>
                <template v-if="surveyData.creatorName">{{$t('survey.publisher')}}：{{surveyData.creatorName}}&nbsp;
                </template>
                &nbsp;&nbsp;&nbsp;{{$t('survey.validNum')}}：<span>{{surveyData.participants}}</span>
            </p>
        </section>

        <el-tooltip class="item" effect="dark" :content="$t('questionnaire.export')"
                    placement="top" :hide-after="1000">
            <a :href="exportUrl" class="export-btn"><i class="nucfont inuc-daochu"></i></a>
        </el-tooltip>

        <el-tabs v-model="activeName" class="survey-tabs" type="card"
                 :class="{'tab-user': activeName==='user'}">

            <!-- 问卷统计 -->
            <el-tab-pane :label="$t('questionnaire.defaultReport')" name="table">
                <section class="survey-content" v-for="(item, index) in questions" :key="index">
                    <!-- 评分(1) -->
                    <div class="survey-type" v-if="item.type==1">
                        <h3>
                            <span>{{index+1}}</span>{{item.title}}
                        </h3>
                        <table border="1" width="100%" class="table">
                            <tr class="table-title">
                                <td>{{$t('c.option')}}</td>
                                <td>{{$t('survey.responseNum')}}</td>
                                <td>{{$t('survey.proportion')}}</td>
                            </tr>
                            <tr v-for="i in 5" style="text-align: center">
<!--                                <td>{{singleName(5-i)}}</td>-->
                                <td><el-rate :value="i" disabled></el-rate></td>
                                <td>{{getValue(item.id, i)}}</td>
                                <td>
                                    <el-progress :text-inside="false" :percentage="getPercent(item.id, i)"
                                                 class="survey-progress"
                                                 :stroke-width="12"
                                                 color="#00bcd4"></el-progress>
                                </td>
                            </tr>
                            <tr class="table-title table-footer">
                                <td>{{$t('survey.synthesis')}}</td>
                                <td>{{surveyData.participants}}</td>
                                <td>{{$t('survey.average')}} {{getAverage(item.id)}}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- 单选(2)或多选(3) -->
                    <div class="survey-type" v-if="item.type==2 || item.type==3">
                        <h3>
                            <span>{{index+1}}</span>{{item.title}}
                            <i class="limit" v-if="item.limitChoice">{{$t('questionnaire.maxLimit',
                                [item.limitChoice])}}</i>
                        </h3>
                        <table border="1" width="100%" class="table">
                            <tr class="table-title">
                                <td>{{$t('c.option')}}</td>
                                <td>{{$t('survey.responseNum')}}</td>
                                <td>{{$t('survey.proportion')}}</td>
                            </tr>
                            <template v-for="opt in item.options">
                                <tr>
                                    <td style="min-width: 300px;word-break: break-all; padding: 5px 10px;">
                                        {{opt.title}}
                                    </td>
                                    <td style="min-width: 300px">{{getValue(item.id, opt.id)}}</td>
                                    <td style="min-width: 300px;">
                                        <el-progress :text-inside="false" :percentage="getPercent(item.id, opt.id)"
                                                     class="survey-progress"
                                                     :stroke-width="12"
                                                     color="#00bcd4"></el-progress>
                                    </td>
                                </tr>
                            </template>
                            <tr class="table-title table-footer">
                                <td>{{$t('survey.synthesis')}}</td>
                                <td>{{surveyData.participants}}</td>
                                <td>{{'—'}}</td>
                            </tr>
                        </table>
                    </div>

                    <!-- 主观题(4) -->
                    <div class="survey-type" v-if="item.type==4">
                        <h3>
                            <span>{{index+1}}</span>{{item.title}}
                        </h3>
                        <div class="essay-box">
                            <el-button type="primary" @click="seeEssay(index+1, item)">{{$t('c.viewDetail')}}</el-button>
                        </div>
                    </div>
                </section>
            </el-tab-pane>

            <!-- 人员统计 -->
            <el-tab-pane :label="$t('questionnaire.replyStatistics')" name="user">
                <data-tables class="user-table"
                             ref="trainTable"
                             :data="userData"
                             :table-props="{border: false,stripe: true,height: 'auto'}"
                             :page-size="20"
                             :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column label="#" type="index" width="40" align="center"></el-table-column>
                    <el-table-column prop="userName" :label="$t('c.username')" align="center"
                                     sortable></el-table-column>
                    <el-table-column prop="accountNo" :label="$t('c.account')" align="center"
                                     sortable></el-table-column>
                    <el-table-column prop="mobile" :label="$t('c.phone')" align="center"></el-table-column>
                    <el-table-column prop="replyTime" :label="$t('questionnaire.replyTime')" align="center"
                                     sortable></el-table-column>
                </data-tables>
            </el-tab-pane>
        </el-tabs>

        <!-- 主观题详情 -->
        <el-dialog :title="$t('survey.subjective')"
                   top="10vh"
                   width="60%"
                   custom-class="questionnaire-essay-dialog"
                   :visible.sync="essayDialog"
                   :close-on-click-modal="false"
                   :modal-append-to-body="false">
            <div class="essay-title">
                <h2>{{$t('questionnaire.NO', [currentEssay.index])}}：{{currentEssay.title}}</h2>
                <!-- 过滤空选项 -->
                <el-switch
                    v-model="filtered"
                    :active-text="$t('questionnaire.filterEmpty')"
                    @change="filterChange"
                >
                </el-switch>
            </div>
            <data-tables class="user-table"
                         :data="essayTable"
                         :table-props="{border: false,stripe: true,height: '500'}"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
            >
                <el-table-column label="#" type="index" width="40" align="center"></el-table-column>
                <el-table-column prop="replyTime" :label="$t('questionnaire.replyTime')" width="200" align="center" sortable>
                    <template slot-scope="scope">{{scope.row.replyTime && scope.row.replyTime.slice(0,10)}}</template>
                </el-table-column>
                <el-table-column prop="answer" :label="$t('questionnaire.replyTxt')" align="left"></el-table-column>
                <el-table-column :label="$t('questionnaire.viewPaper')" align="center" width="150">
                    <div class="btn-cell" slot-scope="scope">
                        <i class="nucfont inuc-preview" :title="$t('c.view')"
                           @click="viewPaper(scope.row.userId)"></i>
                    </div>
                </el-table-column>
            </data-tables>
        </el-dialog>

        <!--查看调研问卷-->
        <survey-view v-if="isViewSurveyPaper"
                         :surveyInfo="surveyInfo"
                         :surveyRecord="surveyRecord"
                         usage="review"
                         @close="closeSurvey"></survey-view>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import {screenfull, Ticket} from '@/utils';
    import SubPage from '@/components/Subpage';
    import SurveyView from "@pages/Survey/SurveyView";

    export default {
        components: {
            SubPage,
            SurveyView
        },
        data() {
            return {
                activeName: 'table',
                paperID: this.$route.params.id,
                surveyData: {}, // 调查统计总数据
                questions: [],  // 题目
                record: [], // 作答情况
                userData: [],

                essayDialog: false,
                essayTable: [],
                filtered: false,
                currentEssay: {
                    index: '',
                    title: ''
                },

                isViewSurveyPaper: false,
                surveyInfo: {},
                surveyRecord: []
            }
        },
        created() {
            this.getDetail(this.paperID);
            this.getQuestionnaireUser(this.paperID);
        },
        computed: {
            exportUrl() {
                const ticket = Ticket.get().access_token;
                const culture = this.$i18n.locale;
                return `${APIURI}surveyapi/questionnaire/${this.paperID}/export?access_token=${ticket}&culture=${culture}&ui-culture=${culture}`;
            }
        },
        methods: {
            getDetail(id) {
                api.getQuestionnaireDetail(id).then(res => {
                    let data = res.package;
                    if (!data) return;

                    // 整张问卷的信息
                    this.surveyData = data;

                    // 题目
                    this.questions = data.template.questions;
                    this.record = data.recordCount;
                })
            },

            getQuestionnaireUser(id) {
                api.getQuestionnaireUser(id).then(res => {
                    this.userData = res.package;
                })
            },

            singleName(i) {
                let name = this.$t('survey.star5');
                switch (i) {
                    case 0:
                        name = this.$t('survey.star5');
                        break;
                    case 1:
                        name = this.$t('survey.star4');
                        break;
                    case 2:
                        name = this.$t('survey.star3');
                        break;
                    case 3:
                        name = this.$t('survey.star2');
                        break;
                    case 4:
                        name = this.$t('survey.star1');
                        break;
                }
                return name;
            },

            getValue(questionId, optionId) {
                let value = 0;
                let thisQuestionAnswers = this.record.filter(item => item.questionId == questionId);
                let thisOptionAnswer = thisQuestionAnswers.find(item => item.optionId == optionId);

                if (thisOptionAnswer) {
                    value = thisOptionAnswer.count
                }

                return value;
            },
            getPercent(questionId, optionId) {
                let percent = 0;
                let thisQuestionAnswers = this.record.filter(item => item.questionId == questionId);
                let thisOptionAnswer = thisQuestionAnswers.find(item => item.optionId == optionId);

                if (thisOptionAnswer) {
                    let count = thisOptionAnswer.count;
                    let total = 0;

                    thisQuestionAnswers.forEach(item => {
                        total += item.count
                    });

                    percent = parseInt((count / total) * 100)
                }

                return percent;
            },
            getAverage(questionId) {
                let thisQuestionAnswers = this.record.filter(item => item.questionId == questionId);
                let length = thisQuestionAnswers.length;

                if (length) {
                    let score = 0;
                    let total = 0;

                    thisQuestionAnswers.forEach(item => {
                        score += item.count * ~~item.optionId
                        total += item.count
                    });

                    return (score / total).toFixed(2)
                } else {
                    return this.$t('survey.appraised')
                }
            },

            seeEssay(n, {id, title}) {
                this.currentEssay.index = n;
                this.currentEssay.title = title;
                this.filtered = false;
                this.essayDialog = true;

                api.getQuestionDetail(this.paperID, id).then(res => {
                    this.essayData = res.package;
                    this.essayTable = res.package;
                })
            },
            filterChange(bool) {
                if (bool) {
                    this.essayTable = this.essayData.filter(item => item.answer)
                } else {
                    this.essayTable = [...this.essayData]
                }
            },
            viewPaper(id) {
                screenfull.request();
                this.isViewSurveyPaper = true;
                api.getQuestionnairePaper(this.paperID, id).then(res => {
                    let data = res.package
                    this.surveyInfo = data.template;
                    this.surveyInfo.name = this.surveyData.name;
                    this.surveyRecord = data.records;
                })
            },
            closeSurvey() {
                this.isViewSurveyPaper = false;
            },
        },
    }
</script>

<style scoped lang="scss">
    @import '../../../style/const.scss';

    .survey-title,
    .survey-content {
        width: 95%;
        margin: auto;
    }

    .survey-title {
        text-align: center;
        margin: 0 0 30px;

        .title {
            font-size: 20px;
            padding-left: 20px;
        }

        p {
            float: right;

            span {
                color: #00bcd4;
            }
        }
    }

    .export-btn {
        float: right;
        position: relative;
        margin-top: 12px;
        margin-right: 3%;
        color: #208acc;
        z-index: 1;
        &:hover {
            color: lighten(#208acc,10%)
        }
    }

    .survey-content {
        .survey-type {
            margin-bottom: 20px;
        }

        h3 {
            position: relative;
            padding: 8px 8px 8px 44px;
            line-height: 1.8;
            color: #4d4d4d;
            background: #f4f3f8;
            font-weight: 600;
            word-wrap: break-word;

            span {
                position: absolute;
                top: 10px;
                left: 10px;
                display: inline-block;
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                border-radius: 50%;
                background: #2d7ea9;
                color: #fff;
                font-size: 16px;
                margin-right: 10px;
            }

            .limit {
                float: right;
                padding-right: 10px;
                font-style: normal;
                color: #999;
                font-weight: normal;
            }
        }

        .table {
            border: solid 1px #ebebeb;

            td {
                text-align: center;
                padding: 0 20px;
                height: 30px;
                @media screen and (max-width: 1280px) {
                    min-width: 0!important;
                }
            }
        }

        .table-title {
            font-weight: bold;
            color: #4d4d4d;

            td {
                min-width: 300px;
            }
        }

        .table-footer {
            background: #f4f3f8;
            color: #4d4d4d;
        }

        .essay-box {
            padding: 10px 30px;
            border: solid 1px #ebebeb;
        }
    }

    .survey-tabs {

        /deep/ .el-tabs__nav {
            margin-left: 2%;
        }

        &.tab-user {
            height: calc(100% - 60px);
            display: flex;
            flex-direction: column;

            /deep/ .el-tabs__content {
                display: flex;
                flex-direction: column;
                flex: 1;
            }

            .el-tab-pane {
                height: 100%;
                width: 95%;
                margin: 0 auto;
            }

            .user-table {
                height: 100%;
                display: flex;
                flex-direction: column;
            }
        }
    }

</style>
<style lang="scss">
    #m-questionnaire-statistics {
        .topicPage {
            z-index: 3000;
        }
    }

    .questionnaire-essay-dialog {
        max-width: 1000px;

        .essay-title {
            display: flex;
            margin-bottom: 10px;

            h2 {
                flex: 1;
                padding-right: 10px;
                margin-bottom: 10px;
                font-weight: 600;
            }

            .el-switch {
                flex-shrink: 0;
            }
        }
    }
</style>
